export enum OcrDocumentState {
    PENDING = 'pending',
    PROCESSING = 'processing',
    COMPLETED = 'completed',
    ERROR = 'error',
}

export const NON_VERIFIABLE_OCR_STATES: readonly OcrDocumentState[] = [
    OcrDocumentState.PENDING,
    OcrDocumentState.PROCESSING,
];

export type OcrLinkedType = 'purInvoice' | 'purCreditNote';

export type OcrSource = 'ocr' | 'facturx';

export type OcrErrorCode = 1 | 2 | 3 | null;

export interface OcrListingRow {
    id: number;
    staff_id: number;
    file_name: string;
    linked_type: OcrLinkedType;
    linked_id: number | null;
    created_at: string;
    completed_at: string | null;
    state: OcrDocumentState;
    error_code: OcrErrorCode;
    source: OcrSource;
    supplier: string | null;
    total_excl_tax: string | null;
    currency: string | null;
}
